import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-reason-textarea',
  templateUrl: './reason-textarea.component.html',
  styleUrls: ['./reason-textarea.component.scss'],
  standalone: false
})
export class ReasonTextareaComponent {
  @Input() control!: FormControl;
  @Input() label: string = 'edit-ticket-modal.form.label';
  @Input() placeholder: string = 'edit-ticket-modal.form.placeholder';
  @Input() customClass: string = '';
}
